import { combineReducers } from 'redux';

import type { Action, PageContent } from 'modules/global/generic.types';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

import { FETCH_COUNTRIES, FETCH_COUNTRIES_SUCCESS } from './actionTypes';
import type { Country } from './types';

type CountriesState = {
  // Country entities indexed by ISO 3166-1 alpha-2 (FR, EN, ZW, CN,....)
  data: Record<string, Country>,
  // Currency symbol indexed by ISO 4217 currency code (e.g. { "EUR": "€", "USD": "$" })
  currencies: Record<string, string>,
}

const countriesReducer = combineReducers({
  data: createReducer<CountriesState['data']>({}, {
    [FETCH_COUNTRIES_SUCCESS]: (state, { payload }: Action<PageContent<Country>>) =>
        payload!.content
          .toSorted((a, b) => a.name.localeCompare(b.name))
          .reduce((acc, country) => ({
            ...acc,
            [country.code]: country
          }), state),
  }),
  currencies: createReducer<CountriesState['currencies']>({}, {
    [FETCH_COUNTRIES_SUCCESS]: (state, { payload }: Action<PageContent<Country>>) =>
        payload!.content.reduce((acc, { currency, currencyIsoCode }) => ({
          ...acc,
          [currencyIsoCode]: currency
        }), state),
  }),
  isFetching: loading(FETCH_COUNTRIES)
});

export default countriesReducer;
